import { h as http } from './http-fdc7ba18.js';
import './lookups-705fb53e.js';
import { p as PLACEHOLDERS, U as URLS, A as ADD_TO_CART_EXCEPTION_CODES } from './request.constants-deb285e0.js';
import { s as send, a as addToCartProductCardEvent, i as addToCartMainEvent } from './send-33ade633.js';
import { N as NotificationBannerController } from './controller-0b53c447.js';
import { f as formatString } from './format-string-a043c0ab.js';
import { G as getLocaleCodes, H as getBrandName } from './utils-15ad90ec.js';

const convertToApcProductId = (productId) => {
  return `P-${productId}`;
};
const convertToApcSkuId = (productId) => {
  return `SKU-${productId}`;
};
const addToCartUrl = (hostUrl, localeCode, agentChatCscId) => {
  const { countryCode, languageCode } = getLocaleCodes(localeCode);
  return formatString(URLS.ADD_TO_CART, Object.assign({ [PLACEHOLDERS.HOST]: hostUrl, [PLACEHOLDERS.COUNTRY]: countryCode, [PLACEHOLDERS.LANGUAGE]: languageCode }, (agentChatCscId && { [PLACEHOLDERS.Chat_CSC_ID]: agentChatCscId })));
};
const goToCartUrl = (hostUrl, localeCode) => {
  const { countryCode, languageCode } = getLocaleCodes(localeCode);
  return formatString(URLS.GO_TO_CART, {
    [PLACEHOLDERS.HOST]: hostUrl,
    [PLACEHOLDERS.COUNTRY]: countryCode,
    [PLACEHOLDERS.LANGUAGE]: languageCode,
  });
};
const addToCartSuccessUrl = (localeCode, agentChatCscId) => {
  const { countryCode, languageCode } = getLocaleCodes(localeCode);
  return formatString(URLS.ADD_TO_CART_SUCCESS, Object.assign({ [PLACEHOLDERS.COUNTRY]: countryCode, [PLACEHOLDERS.LANGUAGE]: languageCode }, (agentChatCscId && { [PLACEHOLDERS.Chat_CSC_ID]: agentChatCscId })));
};
const addToCartErrorUrl = (localeCode, agentChatCscId) => {
  const { countryCode, languageCode } = getLocaleCodes(localeCode);
  return formatString(URLS.ADD_TO_CART_ERROR, Object.assign({ [PLACEHOLDERS.COUNTRY]: countryCode, [PLACEHOLDERS.LANGUAGE]: languageCode }, (agentChatCscId && { [PLACEHOLDERS.Chat_CSC_ID]: agentChatCscId })));
};
const availabilityUrl = (hostUrl, localeCode, productId) => {
  const { countryCode, languageCode } = getLocaleCodes(localeCode);
  return formatString(URLS.PRODUCT_AVAILABILITY, {
    [PLACEHOLDERS.HOST]: hostUrl,
    [PLACEHOLDERS.PRODUCT_ID]: productId,
    [PLACEHOLDERS.COUNTRY]: countryCode,
    [PLACEHOLDERS.LANGUAGE]: languageCode,
  });
};
const addToFavoritesUrl = (hostUrl, localeCode) => {
  const { countryCode, languageCode } = getLocaleCodes(localeCode);
  return formatString(URLS.ADD_TO_FAVORITES, {
    [PLACEHOLDERS.HOST]: hostUrl,
    [PLACEHOLDERS.COUNTRY]: countryCode,
    [PLACEHOLDERS.LANGUAGE]: languageCode,
  });
};
const removeFromFavoritesUrl = (hostUrl, localeCode) => {
  const { countryCode, languageCode } = getLocaleCodes(localeCode);
  return formatString(URLS.REMOVE_FROM_FAVORITES, {
    [PLACEHOLDERS.HOST]: hostUrl,
    [PLACEHOLDERS.COUNTRY]: countryCode,
    [PLACEHOLDERS.LANGUAGE]: languageCode,
  });
};
const myAccountListUrl = (hostUrl, localeCode) => {
  const { countryCode, languageCode } = getLocaleCodes(localeCode);
  return formatString(URLS.MY_LIST, {
    [PLACEHOLDERS.HOST]: hostUrl,
    [PLACEHOLDERS.COUNTRY]: countryCode,
    [PLACEHOLDERS.LANGUAGE]: languageCode,
  });
};
const createAccountUrl = (hostUrl, localeCode, productId) => {
  const { countryCode, languageCode } = getLocaleCodes(localeCode);
  return formatString(URLS.CREATE_ACCOUNT, {
    [PLACEHOLDERS.HOST]: hostUrl,
    [PLACEHOLDERS.PRODUCT_ID]: productId,
    [PLACEHOLDERS.COUNTRY]: countryCode,
    [PLACEHOLDERS.LANGUAGE]: languageCode,
  });
};
const signInUrl = (hostUrl, localeCode, productId) => {
  const { countryCode, languageCode } = getLocaleCodes(localeCode);
  return formatString(URLS.SIGN_IN, {
    [PLACEHOLDERS.HOST]: hostUrl,
    [PLACEHOLDERS.PRODUCT_ID]: productId,
    [PLACEHOLDERS.COUNTRY]: countryCode,
    [PLACEHOLDERS.LANGUAGE]: languageCode,
  });
};
const showNotification = ({ notificationController, status, icon, message, }) => {
  if (!notificationController) {
    notificationController = new NotificationBannerController();
  }
  return notificationController.show({
    componentProps: {
      active: true,
      status,
      icon,
      innerHTML: message,
    },
  });
};
const showErrorNotifier = (notificationController, message) => {
  return showNotification({
    notificationController,
    icon: 'general_danger_full',
    message,
    status: "error",
  });
};
const handleAddToCartFormExceptions = (notificationController, exceptions, failedResponse, cartPageUrl) => {
  let message;
  const [exception] = Object.keys(exceptions) || [];
  switch (exception) {
    case ADD_TO_CART_EXCEPTION_CODES.MAXIMUM_COUNT_WITH_LINK: {
      message = exceptions[ADD_TO_CART_EXCEPTION_CODES.MAXIMUM_COUNT_WITH_LINK].replace('onclick=\\"gotoCart()\\"', `href="${cartPageUrl}"`);
      break;
    }
    case ADD_TO_CART_EXCEPTION_CODES.MAXIMUM_COUNT: {
      message = exceptions[ADD_TO_CART_EXCEPTION_CODES.MAXIMUM_COUNT];
      break;
    }
    default: {
      message = failedResponse;
    }
  }
  return showErrorNotifier(notificationController, message);
};
const addToCart = async (notificationController, productId, localeCode, hostUrl, failedResponse, agentChatCscId, gaObj, eventName) => {
  if (!hostUrl) {
    return handleAddToCartFormExceptions(notificationController, {}, failedResponse);
  }
  const apcProductId = convertToApcProductId(productId);
  const url = addToCartUrl(hostUrl, localeCode, agentChatCscId);
  const cartPageUrl = goToCartUrl(hostUrl, localeCode);
  const params = {
    catalogRefIds: `SKU-${productId}`,
    productId: apcProductId,
    quantity: 1,
    addItemToOrderSuccessURL: addToCartSuccessUrl(localeCode, agentChatCscId),
    addItemToOrderErrorURL: addToCartErrorUrl(localeCode, agentChatCscId),
  };
  const response = await postApcAddToCart(url, params);
  if (response.success === 'false') {
    handleAddToCartFormExceptions(notificationController, response.formExceptions, failedResponse, cartPageUrl);
  }
  else {
    if (gaObj) {
      if (eventName && eventName === 'addToCartProductCardEvent') {
        send(addToCartProductCardEvent, gaObj);
      }
      else {
        send(addToCartMainEvent, gaObj);
      }
    }
    window.open(cartPageUrl, '_self');
  }
};
const removeFromFavorites = async ({ hostUrl, localeCode, notificationController, notificationMessages, data, }) => {
  if (!hostUrl) {
    showErrorNotifier(notificationController, notificationMessages.error);
    throw { success: 'false' };
  }
  const url = removeFromFavoritesUrl(hostUrl, localeCode);
  const response = await removeFromFavoritesRequest(url, data);
  if ((response === null || response === void 0 ? void 0 : response.success) !== 'true') {
    showErrorNotifier(notificationController, notificationMessages.error);
    throw response;
  }
  showNotification({
    notificationController,
    icon: 'star_stroke',
    status: "informational",
    message: notificationMessages.success,
  });
  return response;
};
const addToFavorites = async ({ hostUrl, localeCode, notificationController, notificationMessages, data, }) => {
  if (!hostUrl) {
    showErrorNotifier(notificationController, notificationMessages.error);
    throw { success: 'false' };
  }
  const url = addToFavoritesUrl(hostUrl, localeCode);
  const response = await addToFavoritesRequest(url, data);
  if ((response === null || response === void 0 ? void 0 : response.success) !== 'true') {
    showErrorNotifier(notificationController, notificationMessages.error);
    throw response;
  }
  showNotification({
    notificationController,
    icon: 'star_plain',
    message: notificationMessages.success,
    status: "informational",
  });
  return response;
};
const formCtaUrl = (endPoint, params) => {
  const { countryCode, languageCode, brand, productId } = params;
  const brandName = brand || getBrandName();
  let queryParams = `?country-code=${countryCode}&language-code=${languageCode}&brand=${brandName}`;
  if (productId)
    queryParams += `&productId=${productId}`;
  const url = endPoint + queryParams;
  return url;
};

const getApcCta = (apcCtaUrl) => {
  return http.get(apcCtaUrl);
};
const getAvailabilityInfo = (availabilityUrl) => {
  return http.get(availabilityUrl, {}, { credentials: 'include' });
};
const postApcAddToCart = (apcAddToCartUrl, params) => {
  return http.post(apcAddToCartUrl, params, { credentials: 'include' });
};
const removeFromFavoritesRequest = (url, params) => {
  return http.post(url, params, { credentials: 'include' });
};
const addToFavoritesRequest = (url, { giftlistId, productId }) => {
  return http.post(url, {
    giftlistId,
    quantity: 1,
    productId: convertToApcProductId(productId),
    catalogRefIds: [convertToApcSkuId(productId)],
  }, { credentials: 'include' });
};

export { addToCart as a, availabilityUrl as b, getAvailabilityInfo as c, createAccountUrl as d, addToFavorites as e, formCtaUrl as f, getApcCta as g, myAccountListUrl as m, removeFromFavorites as r, signInUrl as s };
